import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, batch } from 'react-redux';
import Svg from '../../shared/Svg';
import colors from '../../../utils/colors';
import * as CalendarActions from '../../../actions/calendar';
import '../../searchContainer/SearchTableItem.scss';

export const NoSelectedRecord = ({ isPrivateEventSF }) => {
  const dispatch = useDispatch();

  const addRecord = () => {
    batch(() => {
      dispatch(CalendarActions.isSelectingRecord(true));
    });
  };

  return (
    <div className="searchTableItem-selectedRecord">
      <div className="searchTableItem-detailsContainer" >
        { isPrivateEventSF ? <div className="searchTableItem-noRecordAllowedText">Private events in Litify cannot be associated with a related record.</div> :
        <>
          <div className="searchTableItem-noRecordText">No saved location</div>
          <div className="searchTableItem-details">Select plus to add saved location</div>
        </>

        }
      </div>
      { !isPrivateEventSF && <Svg
        className="searchTableItem-closeIcon"
        data="../assets/plus.svg"
        fill={colors.searchGrey}
        tooltipContent={<span>Add Record</span>}
        onClickAction={ addRecord }
        hoverable
        hoverFill={colors.iconHover}
      />
      }
    </div>
  );
};

NoSelectedRecord.propTypes = {
  isPrivateEventSF: PropTypes.bool,
};
